import { useEffect, useState } from 'react';

/** Tailwind's `lg`. Below it there is no room for two panes side by side. */
const WIDE = '(min-width: 1024px)';

/**
 * Whether the viewport is wide enough for the two-pane layout.
 *
 * A media query rather than a CSS-only solution because the difference is not
 * cosmetic: narrow shows *one* of list and detail, so which one is mounted has
 * to be a decision the component makes, not a `hidden` class on markup that is
 * rendered either way.
 */
export function useIsWide(): boolean {
  const [wide, setWide] = useState(() => window.matchMedia?.(WIDE).matches ?? true);

  useEffect(() => {
    const query = window.matchMedia?.(WIDE);
    if (!query) return;

    const sync = (): void => setWide(query.matches);
    sync();

    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  return wide;
}
